import {charcoal, white} from '../sass/base/_exports.sass';

export const CheckmarkFilledCircleIcon = ({
  color = charcoal,
  fillColor = white,
  className = '',
  ratio = 1,
}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
    >
      <circle
        style={{fill: fillColor, fillOpacity: 1, strokeWidth: 1.45698}}
        cx="16.063"
        cy="15.129"
        r="12.282"
      />
      <path
        d="M15.77 31.54C7.06 31.54 0 24.48 0 15.77S7.06 0 15.77 0s15.77 7.06 15.77 15.77-7.06 15.77-15.77 15.77zm-1.572-9.462 11.15-11.151-2.23-2.23-8.92 8.921-4.462-4.461-2.23 2.23Z"
        style={{strokeWidth: 1.18275}}
        fill={color}
      />
    </svg>
  );
};
